import { Button } from "antd";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { PhoneFilled } from "@ant-design/icons";
import { emergencyContactLoginApi } from "api/auth";
import NormalInput from "components/Form/NormalInput";
import PasswordInput from "components/Form/PasswordInput";
import { useNotificationContext } from "contexts/NotificationContext";
import { IEmergencyContactLoginInput } from "models/auth";
import emergencyContactLoginValidator from "validators/emergencyContactLogin.validator";
import { useLocation } from "react-router-dom";

export default function TrackerLogin({
  handleClose,
}: {
  handleClose: () => void;
}) {
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<IEmergencyContactLoginInput>({
    resolver: yupResolver(emergencyContactLoginValidator),
  });
  const location = useLocation();

  const onSubmit = async (input: IEmergencyContactLoginInput) => {
    setLoading(true);
    const type = location.pathname.split("/")[1];
    const { data, error } = await emergencyContactLoginApi(input, type);
    if (data) {
      localStorage.setItem("token", data.token.access_token);
      showSuccess("Successfully logged in");
      handleClose();
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };
  return (
    <div
      className="w-full absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center"
      style={{ backgroundColor: "#00000077" }}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full flex flex-col gap-y-4 mt-5 bg-white max-w-md p-10 rounded-xl"
      >
        <h4 className="font-semibold text-lg text-center">Login</h4>
        <p className="text-base font-normal text-center">
          Welcome back, please login to your account to track driver
        </p>
        <NormalInput
          control={control}
          name="phone"
          placeholder="Phone"
          type="tel"
          prefix={
            <span className="flex items-center gap-x-2">
              <PhoneFilled />
              +251
            </span>
          }
        />
        <PasswordInput
          control={control}
          name="password"
          placeholder="Password"
        />
        <div className="w-full">
          <Button
            loading={loading}
            htmlType="submit"
            type="primary"
            className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
          >
            Login
          </Button>
        </div>
      </form>
    </div>
  );
}
